import TableTabs from './TableTabs';
import connectContainer from './TableTabsContainer';

export default connectContainer(TableTabs);
